import cn from 'classnames';
import { createContext } from 'react';

import { ToothChartSize } from '../../config/types';

import styles from './ToothChartRoot.module.scss';

export const ToothChartContext = createContext<ToothChartSize>('default');

type ToothChartRootProps = {
  children: React.ReactNode;
  className?: string;
  size?: ToothChartSize;
};

const sizeStyles: Record<ToothChartSize, string> = {
  default: styles.sizeDefault,
  small: styles.sizeSmall,
  mobile: styles.sizeMobile,
};

export const ToothChartRoot = (props: ToothChartRootProps) => {
  const { size = 'default', children, className } = props;

  return (
    <ToothChartContext.Provider value={size}>
      <div
        className={cn(styles.container, sizeStyles[size], className)}
        data-component="tooth-chart-root"
      >
        {children}
      </div>
    </ToothChartContext.Provider>
  );
};
